import moment, { Moment } from 'moment';
import { getStages } from '../../components/API/stage';

export function removeDeletedStages(line) {
  line.stages = line.stages.filter((stage) => stage.deleted !== true);
  return line;
}

export function setRepayStartDateNewLine(sellingStart: Moment) {
  let date = moment(sellingStart);
  date.day() >= 4 ? date.add(2, 'weeks') : date.add(1, 'week');
  return date.day(4);
}

export function setCompleteDateNewLine(
  sellingStartDate: Moment,
  lastStageDate: Moment,
) {
  // START WITH SELLING START TO DETERMINE COMPLETE
  let date = moment(sellingStartDate);
  date.day() >= 4 ? date.add(8, 'weeks') : date.add(7, 'weeks');
  if (date.day(4) > lastStageDate) return date.day(4);
  // IF SELLING START + 8 WEEKS IS NOT BEFORE LAST STAGE, USE LAST STAGE
  date = moment(lastStageDate);
  date.day() >= 4 ? date.add(4, 'weeks') : date.add(3, 'weeks');
  return date.day(4);
}

export async function getSpecificStages(
  lineId: string,
  stagesToGet: Array<string>,
) {
  try {
    let stages = await getStages(lineId, [...stagesToGet]);
    return stages;
  } catch {
    return false;
  }
}
